import { defaultApiClient } from "../libs";

export const fetch = async (abTestId) => {
  const { data } = await defaultApiClient.get(`/api/v1/ab-test/${abTestId}`)
  return data.data
}
